/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

window.Vue = require('vue')
window.axios = require('axios')
window._ = require('lodash')
window.collect = require('collect.js')
window.Velocity = require('velocity-animate')
window.Pusher = require('pusher-js')
window.moment = require('moment')

/**
 * We'll register a HTTP interceptor to attach the "CSRF" header to each of
 * the outgoing requests issued by this application. The CSRF middleware
 * included with Laravel will automatically verify the header's value.
 */

window.axios.defaults.headers.common = {
    // 'X-CSRF-TOKEN': window.App.csrfToken,
    'X-Requested-With': 'XMLHttpRequest',
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from "laravel-echo"

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: '45eef0c2deb965dce190',
//     cluster: 'us2',
//     namespace: ''
// })


// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js